module.exports = __webpack_public_path__ + "img/riches.22c51142.jpg";